import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { db } from "../../firebaseConfig";
import {
  collection,
  getDocs,
  orderBy,
  query,
  where,
} from "firebase/firestore";


export const filterData = createAsyncThunk(
  "data/filterData",
  async ({ startDate, endDate, agence = "all" }, { rejectWithValue }) => {
    try {
      const ref = collection(db, "saving");
      
      const conditions = [
        where("date", ">=", startDate),
        where("date", "<=", endDate),
        orderBy("date", "asc")
      ];
      
      if (agence !== "all") {
        conditions.push(where("agence", "==", agence));
      }
      
      const q = query(ref, ...conditions);
      
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
    } catch (error) {
      console.error("Error fetching data:", error);
      return rejectWithValue(error.message || "An error occurred while fetching data.");
    }
  }
);




export const dataSlice = createSlice({
  name: "data",
  initialState: {
    isLoading: false,
    data: [],
    error: null,
  },
  reducers: {
    resetData(state) {
      state.data = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(filterData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(filterData.fulfilled, (state, action) => {
        state.data.push(action.payload);
        state.isLoading = false;
      })
      .addCase(filterData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
  },
});
export const { resetData } = dataSlice.actions;
export default dataSlice.reducer;
